import React from 'react';
import { observer } from 'mobx-react';
import { useAuthStore } from '../../contexts/mobx';
import { useNavigation } from '../../utils/use-navigation';
import { Spin } from 'antd';
import style from './style.module.scss';

/**
 * Component for automatic redirection based on user permissions.
 * Redirects to the first accessible page to avoid showing an empty page.
 */
export const LandingPage = observer(() => {
    const authStore = useAuthStore();
    const navigation = useNavigation();

    const {
        hasManagementAccess,
        isCustomerServiceAgent,
        accessTokenClaims,
    } = authStore;

    React.useEffect(() => {
        // Wait for claims to load
        if (!accessTokenClaims) {
            return;
        }

        // Redirection logic based on permissions
        if (hasManagementAccess) {
            // Admin or Manager → Users analytics (full access)
            navigation.goToUsersAnalytics();
        } else if (isCustomerServiceAgent) {
            // Customer Service Agent → Clients (first accessible page)
            navigation.goToClients();
        } else {
            // Cashier or others → Users analytics (limited view)
            navigation.goToUsersAnalytics();
        }
    }, [
        accessTokenClaims,
        hasManagementAccess,
        isCustomerServiceAgent,
        navigation,
    ]);

    // Show a loading indicator while redirecting
    return (
        <div className={style.landing_container}>
            <div className={style.loading_content}>
                <Spin size="large" />
                <p>Redirection in progress...</p>
            </div>
        </div>
    );
});
